import { Phone, MapPin, Clock, Snowflake, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-10 h-10 rounded-2xl bg-[#E31837] flex items-center justify-center">
                <Snowflake className="w-5 h-5 text-white" strokeWidth={2.4} />
              </div>
              <div className="leading-tight">
                <div className="font-display font-extrabold text-lg text-white">Koehn Cooling</div>
                <div className="text-[11px] uppercase tracking-widest text-slate-400 font-semibold">
                  Hiawatha · Kansas
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              Your local Lennox Dealer providing reliable, honest HVAC service to
              homes and businesses across Northeast Kansas.
            </p>
          </div>

          <div>
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-widest mb-5">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#E31837] flex-shrink-0" />
                <a href="tel:7852880330" data-testid="footer-phone" className="hover:text-white">
                  785-288-0330
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#E31837] flex-shrink-0" />
                <a href="mailto:koehncooling@gmail.com" data-testid="footer-email" className="hover:text-white break-all">
                  koehncooling@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#E31837] flex-shrink-0" />
                <span>1913 Iowa Street<br />Hiawatha, KS 66434</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-widest mb-5">
              Hours
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-[#E31837] flex-shrink-0" />
                <div>
                  <div className="text-white font-medium">Mon – Fri</div>
                  <div className="text-slate-400">8:00 AM – 5:00 PM</div>
                </div>
              </li>
              <li className="text-slate-400 pl-7">Sat – Sun: Closed</li>
              <li className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#E31837]/20 border border-[#E31837]/40 text-[#FCA5A5] text-xs font-semibold">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E31837] animate-pulse" />
                24/7 Emergency Service
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-widest mb-5">
              Services
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                "AC Install & Repair",
                "Heating & Furnaces",
                "Heat Pumps",
                "Indoor Air Quality",
                "Preventive Maintenance",
                "Commercial HVAC",
              ].map((s) => (
                <li key={s}>
                  <a href="#services" className="text-slate-400 hover:text-white transition-colors">
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Koehn Cooling. All rights reserved.</div>
          <div className="flex items-center gap-2">
            <span>Authorized</span>
            <span className="font-display font-extrabold tracking-[0.2em] text-[#E31837]">LENNOX</span>
            <span>Dealer</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
